import * as React from "react";
import {Button, FormControlLabel, FormGroup, Grid, Switch, TextField} from "@material-ui/core";
import {API} from "aws-amplify";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import {Alert} from "@material-ui/lab";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";
import {
    cancelPacketsEnrollmentDefault,
    ICancelPacketsEnrollmentRequest
} from "./request/CancelPacketsEnrollmentRequest";
import { AMAZON_ID } from "../../../../consts/Patterns";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: string
    isJsonInput: boolean
    isLoading: boolean
    jsonInput: string
    request: ICancelPacketsEnrollmentRequest
    response: any
}

enum InputField {
    CONTRACT_ID,
    PROGRAM_NAME,
    VERSION
}

class CancelPacketsEnrollmentSection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            isJsonInput: false,
            isLoading: false,
            jsonInput: cancelPacketsEnrollmentDefault,
            request: {} as ICancelPacketsEnrollmentRequest,
            response: ''
        };

        this.toggleJsonInput = this.toggleJsonInput.bind(this);
        this.setRequest = this.setRequest.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
    }

    public render() {
        return(
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Alert variant="filled" severity="info">
                    Please make sure a customer is enrolled to Packets before running this.
                </Alert>

                <Grid item xs>
                    <FormGroup>
                        <FormControlLabel control={ <Switch onChange={ this.toggleJsonInput }/> } label="Toggle Json Input" />
                    </FormGroup>
                </Grid>


                { !this.state.isJsonInput &&
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Contract Id (Required)"
                                variant="outlined"
                                value={ this.state.request.contractId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.CONTRACT_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="ProgramName (Required)"
                                variant="outlined"
                                value={ this.state.request.programName || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PROGRAM_NAME, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Contract Version (Required)"
                                variant="outlined"
                                value={ this.state.request.version || ''}
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.VERSION, event) }
                            />
                        </Grid>
                    </Grid>
                }

                { this.state.isJsonInput &&
                    <Grid item xs>
                        <TextField
                            multiline
                            rows={ 8 }
                            label="Cancel Packets Enrollment Request"
                            variant="filled"
                            value={ this.state.jsonInput }
                            onChange={ this.setRequest }
                            style={{ width: 800 }}
                        />
                    </Grid>
                }

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Submit
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Status</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    private toggleJsonInput() {
        this.setState({ isJsonInput: !this.state.isJsonInput });
    }

    private handleValidation() {
        let formIsValid = true;
        if (!this.state.request.contractId) {
            alert('Please enter the contract id');
            formIsValid = false
        } else if (!this.state.request.contractId.match(AMAZON_ID)) {
            alert('Please enter the valid contract id.');
            formIsValid = false
        }
        if (!this.state.request.programName) {
            alert('Please enter the programName');
            formIsValid = false
        }
        if (!this.state.request.version) {
            alert('Please enter the version');
            formIsValid = false
        }
        return formIsValid;
    }

    private setRequestFields(field: InputField, event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: ICancelPacketsEnrollmentRequest = this.state.request;

        switch (field) {
            case InputField.PROGRAM_NAME: {
                updatedRequest.programName = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.CONTRACT_ID: {
                updatedRequest.contractId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.VERSION: {
                updatedRequest.version = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            default: {
                break;
            }
        }
    }

    private setRequest(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ jsonInput: event.target.value });
    }

    private handleSubmit() {
        this.setState({ isLoading: true });
        this.setState({ errorMessage: '' });

        if (this.handleValidation()) {
            const config = {
                body: {
                    contractId: this.state.request.contractId,
                    programName: this.state.request.programName,
                    version: this.state.request.version
                },
                headers: {}
            }
            this.callCancelPacketsEnrollment(config);
        }
        this.setState({ isLoading: false });
    }

    private callCancelPacketsEnrollment(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/pharmacy-customer/cancel-program-enrollment';

        console.log(config)
        API.post(apiName, path, config).then((getResponse: any) => {
            console.log(getResponse);
            this.setState({ response: getResponse });
            this.setState({ errorMessage: ''})
        }).catch((error) => {
            console.log(error);
            this.setState({ response: ''})
            this.setState({ errorMessage: error.response.data.message });
        });
    }
}

export default CancelPacketsEnrollmentSection;
